import React from "react";
import { useTranslation } from "react-i18next";

const CenterInfoCard = ({ IconImage, label, value }) => {
  const { t } = useTranslation();
  return (
    <div className="col">
      <div className="center-information-card">
        <IconImage className="information-card-icon" />
        <span className="information-card-heading">{t(label)}</span>
        <span className="information-card-value">{value}</span>
      </div>
    </div>
  );
};

export default CenterInfoCard;
